// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2440p","col":"styles_col__3F7o_"};